import config from '../config';

const imageRequest = async (URN, method = 'GET') => {
    const options = {
        method,
        headers: {
            'x-access-token': config.tokensecret,
        },
        credentials: 'include',
    };

    let res;
    try {
        res = await fetch(URN, options).then((res) => res.blob());
    } catch (error) {
        throw error;
    }

    try {
        const objectURL = URL.createObjectURL(res);

        return objectURL;
    } catch (e) {
        if (e.type === 'ApiError') {
            throw e;
        }
    }

    return res;
};

export default imageRequest;
